"use client";

import { useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/ui/tooltip";
import { cn } from "@/lib/utils";

/**
 * Plain-language one-liner on hover, focus and tap. Controlled so a tap
 * (mobile has no hover) toggles it too.
 */
export default function InfoTip({
  label,
  children,
  className,
  side = "top",
}: {
  /** accessible name for the trigger, e.g. "What is Max Drawdown?" */
  label: string;
  children: React.ReactNode;
  className?: string;
  side?: "top" | "bottom" | "left" | "right";
}) {
  const [open, setOpen] = useState(false);

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip
        open={open}
        onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={label}
            onClick={() => setOpen((v) => !v)}
            className={cn(
              "inline-flex h-[2.25rem] w-[2.25rem] shrink-0 items-center justify-center rounded-full text-black/40 transition-colors hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-[#307f6a] focus-visible:ring-offset-1",
              className,
            )}>
            <svg
              viewBox="0 0 16 16"
              fill="none"
              className="h-[2rem] w-[2rem]"
              aria-hidden="true">
              <circle
                cx="8"
                cy="8"
                r="6.75"
                stroke="currentColor"
                strokeWidth="1.3"
              />
              <path
                d="M8 7.2v4"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
              />
              <circle
                cx="8"
                cy="4.9"
                r="0.9"
                fill="currentColor"
              />
            </svg>
          </button>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className="max-w-[36rem] rounded-[0.5rem] bg-[#0d2922] px-[1.75rem] py-[1.25rem] font-geist text-[1.75rem] leading-[1.4] font-normal text-white normal-case shadow-lg">
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
